import React, { Component } from "react";
import PropTypes from "prop-types";
import { Link } from "@reach/router";
import Heading from "~/scripts/components/Heading";
import BodyCopy from "~/scripts/components/BodyCopy";

class NotFound extends Component {
    static propTypes = {
        onMount: PropTypes.func
    };

    componentDidMount() {
        const { onMount } = this.props;

        if (onMount) {
            onMount();
        }
    }

    render() {
        return (
            <div className="page-wrapper">
                <div className="not-found">
                    <Heading>Nothing to see here.</Heading>
                    <BodyCopy>
                        All the good stuff is on our{" "}
                        <Link to="/">Homepage</Link>.
                    </BodyCopy>
                </div>
            </div>
        );
    }
}

export default NotFound;



// WEBPACK FOOTER //
// ./src/scripts/components/pages/NotFound.js